
import React, { useState } from "react";
import "./Bankinvoice.css"; // Import the CSS file

const TabComponent = () => {
  const [activeTab, setActiveTab] = useState("KTNL");

  const tabs = ["KTNL", "BR Academy", "Cogniitec", "Multiscale Effect", "KTMC"];

  const renderContent = () => {
    switch (activeTab) {
      case "KTNL":
        return (
          <div className="tab-content">
            {/* Left and Right Cards */}
            <div className="card-container">
              {/* Left Card */}
              <div className="card left-card">
                <h3 className="form-title">Inward</h3>
                <form className="form-container">
                  {/* Dropdown Field */}
                  <div className="form-group">
                    <label>Payment Method:</label>
                    <select name="paymentMethod" className="form-input">
                    <option value="" disabled selected>Select</option>

                      <option value="cash">Cash</option>
                      <option value="cheque">Cheque</option>
                      <option value="account">Account</option>
                    </select>
                                    </div>
                    {/* Amount */}
                    <div className="form-group">
                     <label>Amount</label>
                      <input type="text" name="authorizedPerson" className="form-input" />
                       </div>
                    {/* Amount */}

                  {/* Authorized Person */}
                  <div className="form-group">
                    <label>Authorized Person:</label>
                    <input type="text" name="authorizedPerson" className="form-input" />
                  </div>

                  {/* Approved Field */}
                 
                <div className="form-group">
                <label>Approved</label>
                <select name="paymentMethod" className="form-input">
                    <option value="" disabled selected>Select</option>
                    <option value="cash">Yes</option>
                    <option value="cheque">No</option>
                </select>
                </div>


                  {/* Description Field */} 
                  <div className="form-group">
                    <label>Description:</label>
                    <input type="text" name="description" className="form-input" />
                  </div>

                  {/* Submit Button */}
                  <button type="submit" className="form-button">
                    Submit Inward
                  </button>
                </form>
              </div>

              {/* Right Card */}
              <div className="card right-card">
                <h3 className="form-title">Outward</h3>
                <form className="form-container">
                  {/* Dropdown Field */}
                  <div className="form-group">
                    <label>Payment Method:</label>
                    <select name="paymentMethod" className="form-input">
                      <option value="" disabled selected>Select</option>

                      <option value="cash">Cash</option>
                      <option value="cheque">Cheque</option>
                      <option value="account">Account</option>
                    </select>
                                    </div>
                    {/* Amount */}
                    <div className="form-group">
                    <label>Amount</label>
                    <input type="text" name="authorizedPerson" className="form-input" />
                    </div>
                   {/* Amount */}

                  {/* Authorized Person */}
                  <div className="form-group">
                    <label>Authorized Person:</label>
                    <input type="text" name="authorizedPerson" className="form-input" />
                  </div>

                  {/* Approved Field */}
                  <div className="form-group">
                <label>Approved</label>
                <select name="paymentMethod" className="form-input">
                    <option value="" disabled selected>Select</option>
                    <option value="cash">Yes</option>
                    <option value="cheque">No</option>
                </select>
                </div>
                  {/* Description Field */}
                  <div className="form-group">
                    <label>Description:</label>
                    <input type="text" name="description" className="form-input" />
                  </div>

                  {/* Submit Button */}
                  <button type="submit" className="form-button">
                    Submit Outward
                  </button>
                </form>
              </div>
            </div>
          </div>
        );
      case "BR Academy":
        return (
            <div className="tab-content">
            {/* Left and Right Cards */}
            <div className="card-container">
              {/* Left Card */}
              <div className="card left-card">
                <h3 className="form-title">Inward</h3>
                <form className="form-container">
                  {/* Dropdown Field */}
                  <div className="form-group">
                    <label>Payment Method:</label>
                    <select name="paymentMethod" className="form-input">
                      <option value="" disabled selected>Select</option>

                      <option value="cash">Cash</option>
                      <option value="cheque">Cheque</option>
                      <option value="account">Account</option> 
                    </select>
                  </div>
                  {/* Amount */}
                  <div className="form-group">
                    <label>Amount</label>
                    <input type="text" name="authorizedPerson" className="form-input" />
                  </div>
                  {/* Amount */}

                  {/* Authorized Person */}
                  <div className="form-group">
                    <label>Authorized Person:</label>
                    <input type="text" name="authorizedPerson" className="form-input" />
                  </div>

                  {/* Approved Field */}
                  <div className="form-group">
                <label>Approved</label>
                <select name="paymentMethod" className="form-input">
                    <option value="" disabled selected>Select</option>
                    <option value="cash">Yes</option>
                    <option value="cheque">No</option>
                </select>
                </div>

                  {/* Description Field */}
                  <div className="form-group">
                    <label>Description:</label>
                    <input type="text" name="description" className="form-input" />
                  </div>

                  {/* Submit Button */}
                  <button type="submit" className="form-button">
                    Submit Inward
                  </button>
                </form>
              </div>

              {/* Right Card */}
              <div className="card right-card">
                <h3 className="form-title">Outward</h3>
                <form className="form-container">
                  {/* Dropdown Field */}
                  <div className="form-group">
                    <label>Payment Method:</label>
                    <select name="paymentMethod" className="form-input">
                    <option value="" disabled selected>Select</option>
                      <option value="cash">Cash</option>
                      <option value="cheque">Cheque</option>
                      <option value="account">Account</option>
                    </select>
                  </div>
                {/* Amount */}
                  <div className="form-group">
                    <label>Amount</label>
                    <input type="text" name="authorizedPerson" className="form-input" />
                  </div>
                   {/* Amount */}

                  {/* Authorized Person */}
                  <div className="form-group">
                    <label>Authorized Person:</label>
                    <input type="text" name="authorizedPerson" className="form-input" />
                  </div>

                  {/* Approved Field */}
                  <div className="form-group">
                <label>Approved</label>
                <select name="paymentMethod" className="form-input">
                    <option value="" disabled selected>Select</option>
                    <option value="cash">Yes</option>
                    <option value="cheque">No</option>
                </select>
                </div>
                  {/* Description Field */}
                  <div className="form-group">
                    <label>Description:</label>
                    <input type="text" name="description" className="form-input" />
                  </div>

                  {/* Submit Button */}
                  <button type="submit" className="form-button">
                    Submit Outward
                  </button>
                </form>
              </div>
            </div>
          </div>
        )
      case "Cogniitec":
        return (
            <div className="tab-content">
  {/* Left and Right Cards */}
  <div className="card-container">
    {/* Left Card */}
    <div className="card left-card">
      <h3 className="form-title">Inward</h3>
      <form className="form-container">
        {/* Dropdown Field */}
        <div className="form-group">
                    <label>Payment Method:</label>
                    <select name="paymentMethod" className="form-input">
                    <option value="" disabled selected>Select</option>
                      <option value="cash">Cash</option>
                      <option value="cheque">Cheque</option>
                      <option value="account">Account</option>
                    </select>
                                    </div>
                    {/* Amount */}
                    <div className="form-group">
                    <label>Amount</label>
                    <input type="text" name="authorizedPerson" className="form-input" />
                    </div>
                   {/* Amount */}

        {/* Authorized Person */}
        <div className="form-group">
          <label>Authorized Person:</label>
          <input type="text" name="authorizedPerson" className="form-input" />
        </div>

        {/* Approved Field */}
        <div className="form-group">
                <label>Approved</label>
                <select name="paymentMethod" className="form-input">
                    <option value="" disabled selected>Select</option>
                    <option value="cash">Yes</option>
                    <option value="cheque">No</option>
                </select>
                </div>

        {/* Description Field */}
        <div className="form-group">
          <label>Description:</label>
          <input type="text" name="description" className="form-input" />
        </div>

        {/* Submit Button */}
        <button type="submit" className="form-button">
          Submit Inward
        </button>
      </form>
    </div>

    {/* Right Card */}
    <div className="card right-card">
      <h3 className="form-title">Outward</h3>
      <form className="form-container">
        {/* Dropdown Field */}
        <div className="form-group">
                    <label>Payment Method:</label>
                    <select name="paymentMethod" className="form-input">
                    <option value="" disabled selected>Select</option>
                      <option value="cash">Cash</option>
                      <option value="cheque">Cheque</option>
                      <option value="account">Account</option>
                    </select>
                                    </div>
                    {/* Amount */}
                    <div className="form-group">
                     <label>Amount</label>
                      <input type="text" name="authorizedPerson" className="form-input" />
                      </div>
                    {/* Amount */}

        {/* Authorized Person */}
        <div className="form-group">
          <label>Authorized Person:</label>
          <input type="text" name="authorizedPerson" className="form-input" />
        </div>

        {/* Approved Field */}
       
        <div className="form-group">
                <label>Approved</label>
                <select name="paymentMethod" className="form-input">
                    <option value="" disabled selected>Select</option>
                    <option value="cash">Yes</option>
                    <option value="cheque">No</option>
                </select>
                </div>

        {/* Description Field */}
        <div className="form-group">
          <label>Description:</label>
          <input type="text" name="description" className="form-input" />
        </div>

        {/* Submit Button */}
        <button type="submit" className="form-button">
          Submit Outward
        </button>
      </form>
    </div>
  </div>
</div>

        )
      case "Multiscale Effect":
        return (
            <div className="tab-content">
            {/* Left and Right Cards */}
            <div className="card-container">
              {/* Left Card */}
              <div className="card left-card">
                <h3 className="form-title">Inward</h3>
                <form className="form-container">
                  {/* Dropdown Field */}
                  <div className="form-group">
                    <label>Payment Method:</label>
                    <select name="paymentMethod" className="form-input">
                     <option value="" disabled selected>Select</option>
                      <option value="cash">Cash</option>
                      <option value="cheque">Cheque</option>
                      <option value="account">Account</option>
                    </select>
                     </div>
                    {/* Amount */}
                    <div className="form-group">
                    <label>Amount</label>
                   <input type="text" name="authorizedPerson" className="form-input" />
                  </div>
                  {/* Amount */}

                  {/* Authorized Person */}
                  <div className="form-group">
                    <label>Authorized Person:</label>
                    <input type="text" name="authorizedPerson" className="form-input" />
                  </div>

                  {/* Approved Field */}
                  <div className="form-group">
                <label>Approved</label>
                <select name="paymentMethod" className="form-input">
                    <option value="" disabled selected>Select</option>
                    <option value="cash">Yes</option>
                    <option value="cheque">No</option>
                </select>
                </div>

                  {/* Description Field */}
                  <div className="form-group">
                    <label>Description:</label>
                    <input type="text" name="description" className="form-input" />
                  </div>

                  {/* Submit Button */}
                  <button type="submit" className="form-button">
                    Submit Inward
                  </button>
                </form>
              </div>

              {/* Right Card */}
              <div className="card right-card">
                <h3 className="form-title">Outward</h3>
                <form className="form-container">
                  {/* Dropdown Field */} 
                  <div className="form-group">
                    <label>Payment Method:</label>
                    <select name="paymentMethod" className="form-input">
                    <option value="" disabled selected>Select</option>

                      <option value="cash">Cash</option>
                      <option value="cheque">Cheque</option>
                      <option value="account">Account</option>
                    </select>
                                </div>
                {/* Amount */}
                <div className="form-group">
                <label>Amount</label>
                <input type="text" name="authorizedPerson" className="form-input" />
                 </div>
                  {/* Amount */}

                  {/* Authorized Person */}
                  <div className="form-group">
                    <label>Authorized Person:</label>
                    <input type="text" name="authorizedPerson" className="form-input" />
                  </div>

                  {/* Approved Field */}
                  <div className="form-group">
                <label>Approved</label>
                <select name="paymentMethod" className="form-input">
                    <option value="" disabled selected>Select</option>
                    <option value="cash">Yes</option>
                    <option value="cheque">No</option>
                </select>
                </div>
                  {/* Description Field */}
                  <div className="form-group">
                    <label>Description:</label>
                    <input type="text" name="description" className="form-input" />
                  </div>

                  {/* Submit Button */}
                  <button type="submit" className="form-button">
                    Submit Outward
                  </button>
                </form>
              </div>
            </div>
          </div>
        )
      case "KTMC":
        return (
            <div className="tab-content">
            {/* Left and Right Cards */}
            <div className="card-container">
              {/* Left Card */}
              <div className="card left-card">
                <h3 className="form-title">Inward</h3>
                <form className="form-container">
                  {/* Dropdown Field */}
                  <div className="form-group">
                    <label>Payment Method:</label>
                    <select name="paymentMethod" className="form-input">
                     <option value="" disabled selected>Select</option>
                      <option value="cash">Cash</option>
                      <option value="cheque">Cheque</option>
                      <option value="account">Account</option>
                    </select>
                  </div>
                    {/* Amount */}
                    <div className="form-group">
                   <label>Amount</label>
                  <input type="text" name="authorizedPerson" className="form-input" />
                   </div>
                 {/* Amount */}

                  {/* Authorized Person */}
                  <div className="form-group">
                    <label>Authorized Person:</label>
                    <input type="text" name="authorizedPerson" className="form-input" />
                  </div>

                  {/* Approved Field */}
                  <div className="form-group">
                <label>Approved</label>
                <select name="paymentMethod" className="form-input">
                    <option value="" disabled selected>Select</option>
                    <option value="cash">Yes</option>
                    <option value="cheque">No</option>
                </select>
                </div>


                  {/* Description Field */}
                  <div className="form-group">
                    <label>Description:</label>
                    <input type="text" name="description" className="form-input" />
                  </div>

                  {/* Submit Button */}
                  <button type="submit" className="form-button">
                    Submit Inward
                  </button>
                </form>
              </div>

              {/* Right Card */}
              <div className="card right-card">
                <h3 className="form-title">Outward</h3>
                <form className="form-container">
                  {/* Dropdown Field */}
                  <div className="form-group">
                    <label>Payment Method:</label>
                    <select name="paymentMethod" className="form-input">
                     <option value="" disabled selected>Select</option>
                      <option value="cash">Cash</option>
                      <option value="cheque">Cheque</option>
                      <option value="account">Account</option>
                    </select>
                  </div>
                   {/* Amount */}
                  <div className="form-group">
                    <label>Amount</label>
                    <input type="text" name="authorizedPerson" className="form-input" />
                  </div>
                 {/* Amount */}

                  {/* Authorized Person */}
                  <div className="form-group">
                    <label>Authorized Person:</label>
                    <input type="text" name="authorizedPerson" className="form-input" />
                  </div>

                  {/* Approved Field */}
                  <div className="form-group">
                <label>Approved</label>
                <select name="paymentMethod" className="form-input">
                    <option value="" disabled selected>Select</option>
                    <option value="cash">Yes</option>
                    <option value="cheque">No</option>
                </select>
                </div>

                  {/* Description Field */}
                  <div className="form-group">
                    <label>Description:</label>
                    <input type="text" name="description" className="form-input" />
                  </div>

                  {/* Submit Button */}
                  <button type="submit" className="form-button">
                    Submit Outward
                  </button>
                </form>
              </div>
            </div>
          </div>
        )
      default:
        return null;
    }
  };

  return (
    <div className="tab-component">
              <div className="Viewdata">View</div>

      {/* Tab Headers */}
      <div className="tab-headers">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`tab-button ${activeTab === tab ? "active" : ""}`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="tab-body">{renderContent()}</div>
    </div>
    
  );
};

export default TabComponent;
